<template>
  <div class="FoodDemo">
    <div class="order-item-title">表单详情</div>
    <div class="TheGoods boxShadow" v-for="(item, index) in info.orderServiceList" :key="index"  @click="jump">
      <img :src="item.picUrl+'?imageView2/1/w/134/h/100'" alt="" class="goodsimg in_b">
      <div class="Goodsmidd in_b">
        <p class="Goodstitel ellipse2">{{ item.title }}</p>
        <p class="Goodssec textOver">{{ item.attrNorm	}}</p>
        <p class="price">单价：{{item.price / 100}} 元
          <span class="yuanjia">数量：× {{item.num}}</span>
        </p>
        <p>
          <el-rate v-model="item.servicesScore" :texts="rateText" show-text disabled :colors="['#d0011b', '#d0011b', '#d0011b']" disabled-void-color="#aaa"></el-rate>
        </p>
      </div>
      <div class="Goodsirig in_b fr">
        <div class="goodsIcon" @click="enterShop(item.corpId)">
          <img :src="item.logoIcon" alt="" class="merchantslogo in_b">
          <p class="in_b textOver">{{ item.corpName }}</p>
        </div>
      </div>
    </div>
    <div class="foot">
      <p class="address"><b>配送地址：</b> {{info.address}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return{};
      },
    },
  },
  data() {
    return {
      rateText:['非常不满意','不满意','一般','比较满意','非常满意',],
    }
  },
  methods:{
    jump() {
      this.$router.push({ path: `/navigator/parkCompleteSet/foodCourt` });
    },
  },
}
</script>
<style lang="scss" scoped>
.foot{
  clear: both;
  padding: 20px 0;
  font-size: 16px;
}
.fr{
  float: right;
}
.merchantslogo{
  width: 36px;
  height: 36px;
  vertical-align: middle;
  border-radius: 50%;
  border: 1px solid #ccc;
}
.in_b{
  display: inline-block;
}
.TheGoods{
  min-height: 140px;
  background-color: #fff;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 20px;
  cursor: pointer;
  .goodsimg{
    width: 134px;
    height: 100px;
    vertical-align: middle;
  }
  .Goodstitel{
    width: 450px;
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 4px;
  }
  .Goodsmidd{
    line-height: 100px;
    width: 450px;
    vertical-align: middle;
    margin-left: 15px;
    .Goodssec{
      width: 450px;
      font-size: 12px;
      color: #666;
    }
    .price{
      font-size: 16px;
      color: #de2c32;
      margin-top: 4px;
      .yuanjia{
        font-size: 12px;
        color: #999;
        margin-left: 20px;
      }
    }
  }
  .Goodsirig{
    display: flex;
    height: 100px;
    flex-direction: column;
    justify-content: space-between;
    .goodsIcon {
      display: flex;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;
      p {
        font-size: 14px;
        width: 70px;
        padding-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/FoodDemo.vue